
import { Vue, Component, Prop } from "vue-property-decorator";

export interface ErrorNotificationData {
  type: 'dnu' | 'language' | 'scheduling' | 'skills' | 'travel' | 'soft_skills' | 'support_types' | 'certification';
  message: string;
  show: boolean;
  contractorName?: string;
  additionalData?: any;
}

@Component
export default class VisitErrorNotification extends Vue {
  @Prop({ type: Object, required: true }) readonly error!: ErrorNotificationData;
  @Prop({ type: String, default: "" }) readonly customClass!: string;
  @Prop({ type: Boolean, default: true }) readonly show!: boolean;

  get shouldShowError(): boolean {
    return this.show && this.error.show && !!this.error.message;
  }

  get errorMessage(): string {
    return this.error.message;
  }
}
